// Utility to get clinic region from current user
// The region is already available from /auth/me endpoint in currentUser.clinic_region

/**
 * Get clinic region from current user
 * @param {object} currentUser - Current user object from auth context
 * @returns {string|null} - Clinic region (e.g., 'HK', 'SG') or null if not found
 */
export const getClinicRegion = (currentUser) => {
  if (!currentUser) {
    return null;
  }

  return currentUser.clinic_region || null;
};
